import { get } from "lodash";
import { useSelector } from "react-redux";

import {
  REQUEST_MASTER_SLOTS,
  REQUEST_CREATE_MASTER_SLOTS,
  SET_MASTER_SLOTS,
  SUCCESS_CREATE_MASTER_SLOTS,
  ERROR_GET_MASTER_SLOTS,
  ERROR_CREATE_MASTER_SLOTS,
  SET_MESSAGE_MASTER_SLOTS,
  SUCCESS_DELETE_MASTER_SLOTS,
  SUCCESS_UPDATE_MASTER_SLOTS,
  REQUEST_DELETE_MASTER_SLOTS,
  REQUEST_UPDATE_MASTER_SLOTS,
  ERROR_DELETE_MASTER_SLOTS,
  ERROR_UPDATE_MASTER_SLOTS,
  REQUEST_CREATE_GET_MASTER_SLOTS,
  ERROR_CREATE_GET_MASTER_SLOTS,
  SUCCESS_CREATE_GET_MASTER_SLOTS,
} from "./slotsActionTypes";

interface IState {
  busy: boolean;
  message: string;
  masterSlots: any[];
}

const initialState: IState = {
  busy: false,
  message: "",
  masterSlots: [],
};

const slots = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_SLOTS:
    case REQUEST_CREATE_GET_MASTER_SLOTS:
    case REQUEST_CREATE_MASTER_SLOTS:
    case REQUEST_DELETE_MASTER_SLOTS:
    case REQUEST_UPDATE_MASTER_SLOTS:
      return {
        ...state,
        busy: true,
        message: "",
      };

    case SET_MESSAGE_MASTER_SLOTS:
      return {
        ...state,
        message: "",
      };

    case SET_MASTER_SLOTS:
      return {
        ...state,
        busy: false,
        message: "",
        // masterSlots: action.payload,
        masterSlots: Array.isArray(action.payload) ? action.payload : [],
      };

    case SUCCESS_CREATE_MASTER_SLOTS:
      // console.log(action.payload);
      return {
        ...state,
        busy: false,
        message: "",
        // masterSlots: action.payload,
        // masterSlots: [...state.masterSlots, action.payload],
        masterSlots: Array.isArray(state.masterSlots)
          ? [...state.masterSlots, action.payload]
          : [action.payload],
      };
    case SUCCESS_CREATE_GET_MASTER_SLOTS:
      // console.log(action.payload);
      return {
        ...state,
        busy: false,
        message: "",
        // masterSlots: action.payload,
        masterSlots: Array.isArray(action.payload) ? action.payload : [],
        // masterSlots: [...state.masterSlots, action.payload],
      };
    case SUCCESS_DELETE_MASTER_SLOTS:
      return {
        ...state,
        busy: false,
        message: "",
        // masterSlots: state.masterSlots.filter(
        //   (tutorial) => get(tutorial, "_id") !== action.payload
        // ),
        // masterSlots: Array.isArray(state.masterSlots)
        //   ? state.masterSlots.filter(
        //       (tutorial) => get(tutorial, "_id") !== action.payload._id
        //     )
        //   : [],
        masterSlots: {
          ...state.masterSlots,
          [action.payload.type]: state.masterSlots[action.payload.type]?.map(
            (restaurant: any) => {
              if (restaurant._id === action.payload.restaurantId) {
                return {
                  ...restaurant,
                  slots: restaurant.slots.filter(
                    (slot: any) => slot._id !== action.payload._id
                  ),
                };
              }
              return restaurant;
            }
          ),
        },
      };

    case SUCCESS_UPDATE_MASTER_SLOTS:
      return {
        ...state,
        busy: false,
        message: "",
        // masterSlots: state.masterSlots.map((mp) => {
        //   return get(mp, "_id") === action.payload._id ? action.payload : mp;
        // }),
        masterSlots: Array.isArray(state.masterSlots)
          ? state.masterSlots.map((mp) =>
              get(mp, "_id") === action.payload._id ? action.payload : mp
            )
          : [action.payload],
      };

    case ERROR_GET_MASTER_SLOTS:
    case ERROR_CREATE_MASTER_SLOTS:
    case ERROR_UPDATE_MASTER_SLOTS:
    case ERROR_DELETE_MASTER_SLOTS:
    case ERROR_CREATE_GET_MASTER_SLOTS:
      return {
        ...state,
        busy: false,
        message:
          action.payload || "Something happened wrong try again after sometime",
      };
    default:
      return state;
  }
};

export default slots;

export function useSlotsMaster() {
  return useSelector((state: Record<string, any>) => state.slots);
}
